import { render } from "./in-one-icon.vue?vue&type=template&id=05b05196&ts=true"
import script from "./in-one-icon.ts?vue&type=script&lang=ts&external"
export * from "./in-one-icon.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__